import { FC, ReactNode } from 'react';

import { theme, Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';

interface ITextProps extends TextProps {
	fontSize?: number;
	color?: 'tertiary' | 'text' | 'primary' | 'quaternary';
	children: ReactNode;
}

export const Text: FC<ITextProps> = ({ className, children, fontSize = 14, color = 'text', ...props }) => {
	const {
		token: { colorPrimary, colorTextTertiary, colorText, colorTextQuaternary },
	} = theme.useToken();

	const fontColor = {
		primary: colorPrimary,
		tertiary: colorTextTertiary,
		text: colorText,
		quaternary: colorTextQuaternary,
	};

	return (
		<Typography.Text {...props} style={{ fontSize: fontSize, color: fontColor[color] }} className={className}>
			{children}
		</Typography.Text>
	);
};
